import { FC } from "react";
import { twMerge } from "tailwind-merge";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const DoubleSparkleIcon: FC<IconProps> = (props) => {
  const { className, ...svgProps } = props;

  return (
    <svg {...initializeSvgIconProps(svgProps)} className={twMerge("text-lavender", className)}>
      <path
        clipRule="evenodd"
        d="M10.1147 4.07849C10.3172 4.07849 10.4814 4.24267 10.4814 4.4452C10.4814 7.59768 13.1306 9.21745 14.9998 9.21745C15.2024 9.21745 15.3666 9.38163 15.3666 9.58416C15.3666 9.78668 15.2024 9.95086 14.9998 9.95086C13.1625 9.95086 10.4814 11.5388 10.4814 14.7866C10.4814 14.9891 10.3172 15.1533 10.1147 15.1533C9.91214 15.1533 9.74796 14.9891 9.74796 14.7866C9.74796 11.5636 7.18614 9.95086 5.22947 9.95086C5.02695 9.95086 4.86277 9.78668 4.86277 9.58416C4.86277 9.38163 5.02695 9.21745 5.22947 9.21745C7.15923 9.21745 9.74796 7.60034 9.74796 4.4452C9.74796 4.24267 9.91214 4.07849 10.1147 4.07849Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M3.47432 1.6333C3.67684 1.6333 3.84102 1.79748 3.84102 2C3.84102 3.43884 5.07432 4.18702 5.94863 4.18702C6.15116 4.18702 6.31533 4.3512 6.31533 4.55372C6.31533 4.75625 6.15116 4.92042 5.94863 4.92042C5.09057 4.92042 3.84102 5.65268 3.84102 7.13897C3.84102 7.34149 3.67684 7.50567 3.47432 7.50567C3.27179 7.50567 3.10761 7.34149 3.10761 7.13897C3.10761 5.66169 1.91467 4.92042 1 4.92042C0.797476 4.92042 0.633297 4.75625 0.633297 4.55372C0.633297 4.3512 0.797476 4.18702 1 4.18702C1.90344 4.18702 3.10761 3.44147 3.10761 2C3.10761 1.79748 3.27179 1.6333 3.47432 1.6333Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};
